var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowingNotifcation)?_c('div',{staticClass:"global-notification-bar",style:({ zIndex: -_vm.zIndex })},[_vm._t("default"),(_vm.showCloseButton)?_c('aha-icon',{staticClass:"global-notification-close-button",attrs:{"name":"close","width":"18","height":"18","viewBox":"0 0 24 24"},on:{"click":_vm.handleClose}}):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }